export default __webpack_public_path__ + "static/media/mobile-errorh264.05400bea.mp4";